export const LOGO_URL = "/logo-tt.png";

// Transparent, cropped logo. Invert on light theme (white -> black), normal on dark.
export function Logo({ compact = false, className = "" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Teacher Tutor"
      data-testid="app-logo"
      className={`${compact ? "h-12 sm:h-14" : "h-20"} w-auto object-contain invert dark:invert-0 ${className}`}
    />
  );
}

export function Monogram({ size = 96, className = "" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Teacher Tutor"
      className={`w-auto object-contain invert dark:invert-0 ${className}`}
      style={{ height: size }}
    />
  );
}
